import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Facet from './facet/facetContainer';
import SortDropdown from '../sortDropdown/sortDropdownContainer';
import AppliedFacets from './appliedFacets/appliedFacets';
import ListTitle from '../listTitle/listTitle';

class FacetsListLargeUp extends Component {
  constructor() {
    super();

    this.state = {
      activeFacetId: null,
    };

    this.onFacetClick = this.onFacetClick.bind(this);
  }

  onFacetClick(facetId) {
    this.setState(({ activeFacetId }) => ({
      activeFacetId: activeFacetId === facetId ? null : facetId,
    }));
  }

  render() {
    const { facetIds, appliedItemsCount, intl } = this.props;

    if (facetIds.length === 0) {
      return null;
    }

    return (
      <>
        <div
          data-filter-title={intl.formatMessage({
            id: 'products.productgrid.filterBy',
          })}
          className="product-list__product-container"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <div className="product-list__product-filter-header">
            <div className="product-list__product-filter-filters">
              <i className="fa-regular fa-sliders" />
              <div className="product-list__product-filter-title">
                {intl.formatMessage({
                  id: 'products.productgrid.filterBy',
                })}
              </div>
            </div>
            <div className="product-list__sort-toggle">
              <SortDropdown />
            </div>
          </div>
          <div style={{ display: 'flex', borderBottom: '1px solid #E5E6E6' }}>
            <ListTitle />
          </div>

          <AppliedFacets appliedItemsCount={appliedItemsCount} />

          <div className="facet-list-container">
            <ul className="facet-list" data-accordion="facetAccordion">
              {facetIds.map((facetId, index) => (
                <Facet
                  key={facetId}
                  facetId={facetId}
                  index={index}
                  isMediumDown
                  sizeIndicatorDisplayCallback={this.sizeIndicatorDisplayCallback}
                />
              ))}
            </ul>
          </div>
        </div>
      </>
    );
  }
}

FacetsListLargeUp.propTypes = {
  facetIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  appliedItemsCount: PropTypes.number.isRequired,
};

export default injectIntl(FacetsListLargeUp);
